module.exports = __webpack_public_path__ + "ea8c96604705b6e0997c3b948e9d5d85.svg";